import addHours from 'date-fns/addHours';
import dayjs from 'dayjs';

import { AppointmentModel } from '../../models/appointment';

import { Appointment } from './types';

export const convertMovementXDataToAppointmentModel = (
  data: Appointment,
): AppointmentModel => {
  const { appointment_scheduled: appointmentSchedule } = data;

  // Use dayjs for stricter validation than new Date() which is too
  // permissive in V8 (e.g. treats random strings as valid dates)
  const parsedStart = appointmentSchedule?.start_time
    ? dayjs(appointmentSchedule.start_time)
    : null;
  const startDate = parsedStart?.isValid() ? parsedStart.toDate() : new Date();

  const parsedEnd = appointmentSchedule?.end_time
    ? dayjs(appointmentSchedule.end_time)
    : null;
  const endDate = parsedEnd?.isValid()
    ? parsedEnd.toDate()
    : addHours(startDate, 1);

  const appointmentModel: AppointmentModel = {
    externalId: `${data.id}`,
    externalPatientId: `${appointmentSchedule?.patient?.id}`,
    externalPractitionerId: undefined,
    firstName: appointmentSchedule?.patient?.user?.first_name ?? '',
    lastName: appointmentSchedule?.patient?.user?.last_name ?? '',
    startTime: startDate.toISOString(),
    endTime: endDate.toISOString(),
    name: appointmentSchedule?.session_type?.title ?? '',
    description: data.notes ?? '',
    status: data?.is_canceled ? 'CANCELLED' : undefined,
    isArchived: false,
    isImportable: true, // Haven't comme across a case where MX returns unimportable appointments
    sessionType: appointmentSchedule?.session_type?.title ?? '',
    rawEhrData: data,
  };

  return appointmentModel;
};
